import { render, staticRenderFns } from "./PeriodMembersIframe.vue?vue&type=template&id=5e372b10&"
import script from "./PeriodMembersIframe.vue?vue&type=script&lang=ts&"
export * from "./PeriodMembersIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports